const projectKey = 'IGetCool_PROJECT_NAME';
// 项目白名单
const projectWhiteList = ['live'];

// 获取项目projectKey内容
export const getFromProjectName = () => {
  return sessionStorage.getItem(projectKey);
};

// 设置项目projectKey内容
export const removeFromProjectName = () => {
  sessionStorage.removeItem(projectKey);
};

// 判断是否需要自动登录
export const needAutoLogin = () => {
  const projectName = getFromProjectName();
  return projectWhiteList.includes(projectName);
};
